'use client';

import type React from 'react';
import { cn } from '@/libs/tailwind';

type GlitterTextProps = {
  children: React.ReactNode;
  className?: string;
};

export const GlitterText: React.FC<GlitterTextProps> = ({ children, className }) => {
  return (
    <div className={cn('z-50 text-center', className)}>
      <p className="glitter-text inline-block font-noi-grotesk text-header-md tracking-[-1.08px] text-primary-n100">
        {children}
      </p>
    </div>
  );
};
